import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import * as apiCalls from './lib/apiCalls';
import { LanguageContext, LanguageConsumer } from './lib/LanguageContext'
import InstitutionIcon from './InstitutionIcon'
import UserIcon from './UserIcon'
import Footer from './Footer'
import './Landing.css'


class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transition: false,
            isLoggedIn: false
        }
    }

    async componentWillMount() {
        if(this.props.institutionId && this.props.token) {
            const res = await apiCalls.loginAttempt(this.props.institutionId, this.props.token);
            if(res.validated === true) {
                return this.setState(prevState => ({
                    ...prevState,
                    isLoggedIn: true
                }))
            }
        }
        this.setState(prevState => ({
            ...prevState,
            isLoggedIn: false
        }))
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        let content = document.getElementById('content');
        content.scrollTop = 0;
        document.title = this.context.polyglot.t('landingPageTitle');
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                transition: true
            }));
        }, 200)
    }

    render() {
        return(
          <LanguageConsumer>
            {({polyglot}) =>
                (<div className={`Landing ${this.state.transition ? 'transition' : ''}`}>
                    <div className='box'>
                        <div className='content'>
                            <div>
                              <h1 className='smaller'>{polyglot.t('Landing.header1')}</h1>
                              <p>
                                {polyglot.t('Landing.paragraph1')}
                              </p>
                            </div>
                        </div>
                        <div className='button-group'>
                            <a href='#learn-more'>
                               <button id='learn-more-button'>{polyglot.t('Landing.learnMore')} &#8595;</button>
                            </a>
                            {!this.props.isLoggedIn ? (
                                <Link to='/login'>
                                    <button id='login'>{polyglot.t('Landing.login')} &#10230;</button>
                                </Link>
                             ) : (
                                 <Link to='/overview'>
                                     <button id='overview'>{polyglot.t('Landing.overview')} &#10230;</button>
                                 </Link>
                            )}
                        </div>
                        <InstitutionIcon/>
                    </div>
                    <div className='box' id='learn-more'>
                        <h1>{polyglot.t('Landing.header2')}</h1>
                        <div className='content'>
                            <p>
                               {polyglot.t('Landing.paragraph2')}
                            </p>
                        </div>
                        <div className='triangle'></div>
                    </div>
                   <div className='box' id='users'>
                        <h1>{polyglot.t('Landing.header3')}</h1>
                        <div className='content'>
                            <p>
                               {polyglot.t('Landing.paragraph3')}
                            </p>
                        </div>
                        <UserIcon/>
                    </div>
                  <div className='box'>
                        <h1>{polyglot.t('Landing.header4')}</h1>
                        <div className='content'>
                            <p>
                               {polyglot.t('Landing.paragraph4')}
                            </p>
                            <p>
                               {polyglot.t('Landing.paragraph5')}
                            </p>
                            <p>
                               {polyglot.t('Landing.paragraph6')}
                           </p>
                           <p>
                               {polyglot.t('Landing.paragraph7')} <Link to='/help'>{polyglot.t('Landing.usersManual')}</Link>.
                           </p>
                        </div>
                    </div>

                    <Footer/>
                </div>)}
          </LanguageConsumer>
        )
    }
}
Landing.contextType = LanguageContext


export default Landing;



// WEBPACK FOOTER //
// ./src/Landing.js